import {UrlPathConfig} from '../app/models/configs/url-path.config';

export const URL_PATH_CONFIGS: UrlPathConfig = {
    paths: {
        amagnoLinkDocument: 'amagno-link/document/{documentId}',
        auth: 'auth',
        clickFinder: 'click-finder',
        contact: 'me/contacts/{userId}',
        favorites: 'favorites',
        inProgressDocument: 'vault-detail/{vaultId}/in-progress/document/{documentId}',
        lastEdited: 'last-edited',
        magnets: 'magnets',
        newestDocuments: 'newest-documents',
        search: 'search',
        searchQuery: 'search-query',
        smallViewport: 's',
        taskMagnetTaskDocument: 'tasks/vault/{vaultId}/task/{magnetId}/document/{documentId}',
        trashedDocument: 'vault-detail/{vaultId}/trash/document/{documentId}',
        vaultDetail: 'vault-detail',
    }
};
